<div id="shops-by-city-or-district">
    <div class="container">
        
        <div class="row shops-by-city-or-district-no-margin-bottom">
            <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                                
                <search-box-title></search-box-title>

                <search-box></search-box>
            </div>
        </div>
        
        <map></map>
        
        <breadcrumbs breadcrumbs="ctrl.breadcrumbs"></breadcrumbs>
		
		<shop-list></shop-list>

		<city-district-select></city-district-select>
        
		<!-- <shop-highlights></shop-highlights> -->
    </div>
</div>